import { Link } from "react-router-dom";
import type { WatchApp } from "@/mocks/movies";

interface AppCardProps {
  app: WatchApp;
  onDownload: (app: WatchApp) => void;
}

export default function AppCard({ app, onDownload }: AppCardProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200/80 hover:border-accent-300 transition-colors">
      <Link to={`/app/detail/${app.id}`} className="shrink-0 cursor-pointer">
        <div className="w-16 h-16 md:w-[72px] md:h-[72px] rounded-lg overflow-hidden bg-primary-900">
          <img
            src={app.icon}
            alt={`${app.name}图标`}
            title={`${app.name} - 看片APP推荐`}
            className="w-full h-full object-cover"
          />
        </div>
      </Link>

      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <Link
              to={`/app/detail/${app.id}`}
              className="text-base font-semibold text-foreground-900 hover:text-primary-600 transition-colors cursor-pointer"
            >
              {app.name}
            </Link>
            <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px]">
              <span className="px-1.5 py-0.5 rounded bg-accent-100 text-accent-900">{app.category}</span>
              <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900">{app.platforms.join(" · ")}</span>
              <span className="text-foreground-500">{app.size}</span>
            </div>
          </div>
          <span className="flex items-center gap-1 text-xs text-accent-700 shrink-0 font-label">
            <i className="ri-star-fill"></i>
            {app.rating.toFixed(1)}
          </span>
        </div>

        <p className="mt-2 text-sm text-foreground-600 leading-6 line-clamp-2">{app.summary}</p>

        <div className="mt-3 flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={() => onDownload(app)}
            className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-download-2-line"></i>
            下载应用
          </button>
          <Link
            to={`/app/detail/${app.id}`}
            className="inline-flex items-center gap-1 px-3.5 py-1.5 rounded-md border border-background-300 text-xs text-foreground-700 whitespace-nowrap hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看详情
            <i className="ri-arrow-right-s-line"></i>
          </Link>
          <span className="text-[11px] text-foreground-400 ml-auto">{app.downloads}下载</span>
        </div>
      </div>
    </div>
  );
}